export enum RoleEnum {
  Landowner = 'Landowner',
  Admin = 'Admin',
  SuperAdmin = 'SuperAdmin',
  LimitedAdmin = 'LimitedAdmin',
  FinanceAdmin = 'FinanceAdmin',
  None = 'No Role',
}
